// @ts-nocheck
// Exact live (2026-10-15) version restored from the production sourcemap.
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Dialog, IconButton, Typography } from '@mui/material';
import { CloseCircle, Edit } from 'iconsax-react';
import { WidgetHeader } from '../../../../components/common/header/widgetHeader/WidgetHeader';
import { CustomChip } from '../../../../components/common/chip/Chip';
import { useAppSelector } from '@application/store/useStore';
import { HoursStatus } from '@application/common/enums/hours-status';
import { PrimaryGrid } from '@ui/components/common/grid/PrimaryGrid';
import { ClientContractStatus } from '@application/common/enums/client-contract-status';
import dayjs from 'dayjs';
export const RejectedTimeSheet = ({ open, handleClose, onEdit }) => {
    const { timeSheetWithClientInfo } = useAppSelector((state) => state.timeSheet);
    const isTimeSheetEditable = (params) => {
        let assignmentStatus = params.row.assignmentStatus;
        let contractEndDateTime = params.row.contractEndDateTime;
        if (assignmentStatus !== ClientContractStatus.Expired) {
            return true;
        }
        if (!contractEndDateTime) {
            return false;
        }
        const endDate = dayjs(contractEndDateTime);
        const currentDate = dayjs();
        return endDate.isAfter(currentDate);
    };
    const columns = [
        {
            field: 'monthName',
            headerName: 'Timesheets',
            flex: 2
        },
        {
            field: 'allClientNames',
            headerName: 'Client',
            flex: 2
        },
        {
            field: 'status',
            headerName: 'Status',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => _jsx(CustomChip, { value: params.value })
        },
        {
            field: 'edit',
            headerName: 'Edit',
            flex: 0.8,
            renderCell: (params) => (_jsx(IconButton, { onClick: () => handleEdit(params), disabled: !isTimeSheetEditable(params), children: _jsx(Edit, {}) }))
        }
    ];
    const rows = timeSheetWithClientInfo?.timeSheetWithClientInfo?.map((data, index) => {
        return {
            id: index + 1,
            allClientNames: data.assignmentStatus == ClientContractStatus.Expired ?
                `${data.allClientNames} (Expired)` : data.allClientNames,
            monthName: data.monthName,
            status: `${HoursStatus[data.timeSheetStatus]}`,
            month: data.month,
            year: data.year,
            assignmentId: data.assignmentId,
            assignmentStatus: data.assignmentStatus,
            contractEndDate: data.contractEndDate,
            contractEndDateTime: data.contractEndDateTime
        };
    });
    const handleEdit = (params) => {
        const editRejectedData = {
            Month: params.row.month,
            Year: params.row.year,
            AssignmentId: params.row.assignmentId,
            clientName: params.row.allClientNames,
            contractEndDate: params.row.contractEndDate
        };
        params.row.assignmentStatus == ClientContractStatus.Expired ?
            onEdit(editRejectedData, true) :
            onEdit(editRejectedData, false);
    };
    return (_jsx(Dialog, { open: open, onClose: handleClose, maxWidth: false, BackdropProps: {
            sx: {
                backdropFilter: 'blur(3px)',
                backgroundColor: 'rgba(74, 74, 74, 0.25)'
            }
        }, PaperProps: {
            sx: {
                width: '620px',
                maxHeight: '90vh',
                overflow: 'hidden'
            }
        }, children: _jsxs(Box, { sx: {
                position: 'sticky',
                top: 0,
                zIndex: 2,
                backgroundColor: 'white'
            }, children: [_jsxs(WidgetHeader, { background: 'white', children: [_jsx(Typography, { fontSize: '20px', color: 'black', sx: {
                                whiteSpace: 'normal',
                                wordBreak: 'break-word'
                            }, children: "Rejected timesheets" }), _jsx(IconButton, { onClick: handleClose, sx: { padding: { xs: '0px', md: '8px' } }, children: _jsx(CloseCircle, { style: { color: 'black' } }) })] }), _jsx(Box, { sx: {
                        padding: { xs: '16px', md: "25px" },
                        overflowX: 'auto',
                        overflowY: 'auto',
                        maxHeight: 'calc(90vh - 10px)',
                        minWidth: '310px'
                    }, children: _jsx(Box, { sx: { minWidth: '310px' }, children: _jsx(PrimaryGrid, { columns: columns, rows: rows }) }) })] }) }));
};
